import { render, staticRenderFns } from "./MemberFileUploadAccess.vue?vue&type=template&id=167b75b4&scoped=true&"
import script from "./MemberFileUploadAccess.vue?vue&type=script&lang=js&"
export * from "./MemberFileUploadAccess.vue?vue&type=script&lang=js&"
import style0 from "./MemberFileUploadAccess.vue?vue&type=style&index=0&id=167b75b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b75b4",
  null
  
)

export default component.exports